// extracted by mini-css-extract-plugin
export default {"container-fluid":"Footer_container-fluid__k8OOo","wrapper":"Footer_wrapper__kuUp3"};